import { useTranslation } from 'react-i18next'
import Link from '@/routing/Link'
import { Badge } from '@/components/ui/badge'
import { ROUTES } from '@/routes/routes'
import type { DatasetDocumentChipsProps } from '@/types/components/library/dataset-document-chips'
import { describeTabularDocument } from '@/pages/KnowledgeDocumentPage/TabularDocumentPreview'
import { useDatasetReadiness } from '@/pages/KnowledgeDocumentPage/DatasetReadinessCard/useDatasetReadiness'
import { DatasetKindChip } from './DatasetKindChip'
import { DatasetTopicChips } from './DatasetTopicChips'
import { DatasetSimulateAudience } from './DatasetSimulateAudience'

function DatasetChips({ document }: DatasetDocumentChipsProps) {
  const { t } = useTranslation('app')
  const dataset = useDatasetReadiness(document)
  return (
    <div className="flex flex-wrap items-center gap-2 pt-2" data-testid="dataset-document-chips">
      <DatasetTopicChips facets={document.facets} />
      {dataset?.state === 'listed' && dataset.kind !== 'other' && <DatasetKindChip kind={dataset.kind} />}
      {dataset && <DatasetSimulateAudience documentToken={document.token} dataset={dataset} />}
      {dataset?.audience && (
        <Link href={ROUTES.audience(dataset.audience.token)} data-testid="dataset-linked-audience" title={dataset.audience.name}>
          <Badge variant="muted">{t('library.audience.label')}</Badge>
        </Link>
      )}
    </div>
  )
}

/** Outside the document card's link, so its audience link is a separate valid target. */
export function DatasetDocumentChips(props: DatasetDocumentChipsProps) {
  return describeTabularDocument(props.document.mimeType, props.document.originalFilename)?.datasetExtension
    ? <DatasetChips {...props} /> : null
}
